import Vue from 'vue';

const mutations = {
  /**
   * Set the groups property on state
   * with groups parameter.
   *
   * @param state
   * @param groups
   */
  setGroups(state, groups) {
    state.groups = groups;
  },

  /**
   * Set the queries property to a group.
   *
   * @param state
   * @param id
   * @param details
   */
  setQueriesInAGroup(state, { id, queries }) {
    const index = state.groups.data.findIndex((group) => group.id === id);

    Vue.set(state.groups.data[index], 'queries', queries);
  },

  /**
   * Set the availableCosnultations property on state
   * with availableConsultations prop.
   *
   * @param state
   * @param availableConsultations
   */
  setAvailableConsultations(state, availableConsultations) {
    state.availableConsultations = availableConsultations;
  },

  /**
   * Set the documents property on state
   * with documents parameter.
   *
   * @param state
   * @param documents
   */
  setDocuments(state, documents) {
    state.documents = documents;
  },

  /**
   * Set the templates property on state
   * with templates parameter.
   *
   * @param state
   * @param templates
   */
  setTemplates(state, templates) {
    state.templates = templates;
  },

  /**
   * Set the template property on state
   * with template parameter.
   *
   * @param state
   * @param template
   */
  setTemplate(state, template) {
    state.template = template;
  },
};

export default mutations;
